<button class="close-btn" (click)="onClose()"></button>
<div class="header">
  <h1>Invite Team member</h1>
  <form [formGroup]="searchForm">
    <div class="input-container search-bar">
      <input
        placeholder="Invite using email"
        type="email"
        formControlName="email"
        (mouseenter)="$event.stopImmediatePropagation()"
        (mouseleave)="$event.stopImmediatePropagation()"
        matTooltipClass="blue-md-tooltip"
        #tooltip="matTooltip"
        matTooltip="Email already exists in the list"
      />
      <button class="add-btn" [disabled]="searchForm.controls.email.errors" (click)="addUserToList(tooltip)"></button>
    </div>
  </form>
</div>
<div class="users-list">
  @if (!usersList.length) {
    <div class="empty-list w-100">
      <img src="/assets/svg/group-3.svg" width="89" height="98" class="add-icon" />
      <p>Invite by entering email on the field above</p>
      <img src="/assets/svg/Oval.svg" class="arrow" />
    </div>
  }

  @for (user of usersList; track user) {
    <div class="user">
      <gnx-avatar class="col-a" [bgColor]="'#007da8'" [size]="50" [name]="user.email.substr(0, 2)" />
      <div class="col-b">
        <span class="email">{{ user.email }}</span>
      </div>
      @if (showApplicativeRoles) {
        <mat-select
          class="role-select"
          [value]="user.role || ''"
          (selectionChange)="user.role = $event.value"
          placeholder="Default Role"
        >
          @for (role of auth0Store.applicativeRolesData(); track role.role) {
            <mat-option [value]="role.role">
              {{ role.role | snakeCaseTitle }}
            </mat-option>
          }
        </mat-select>
      }
      <mat-select
        class="admin-select"
        [value]="user.admin ? USER_TYPE.admin : USER_TYPE.member"
        (selectionChange)="user.admin = $event.value === USER_TYPE.admin"
      >
        @for (type of USER_TYPE | keyvalue; track type) {
          <mat-option [value]="type.value">
            {{ type.value }}
          </mat-option>
        }
      </mat-select>
      <img
        class="delete-btn m-3"
        src="/assets/svg/trash-can.svg"
        width="18"
        height="17"
        (click)="deleteMember(user.email)"
      />
    </div>
  }
</div>
<div class="footer">
  <button class="send-btn" [disabled]="!usersList.length" (click)="onSendInvitations()">
    @if (!sendingInvitations) {
      <span>Send</span>
    }
    @if (sendingInvitations) {
      <gnx-dots-loader />
    }
  </button>
</div>
